import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { HumbeeTabs, TextField } from '../../../../v2/MUI_custom_component';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { CATEGORY_CONFIG, getQuestionConfig } from '../../config/questionsConfig';
import { ProfilerQuestionID } from '../../config/QuestionEnum';

const TABS = [
  { label: 'Adhyayan', key: 'adhyayan', image: PROFILER_IMAGES.adhyayan },
  { label: 'Children', key: 'children', image:  PROFILER_IMAGES.kids_count },
  { label: 'Children education', key: 'children_education', image:  PROFILER_IMAGES.kids_education_count },
];

const KidsTabCard = ({
  questions = [],
  onChange,
  onSubmit,
  width='300px',
  maxWidth='300px'
}) => {
  const [tab, setTab] = useState(0);
  const [values, setValues] = useState(questions.map(q => q.value ?? ''));

  const handleTabChange = (event, newValue) => setTab(newValue);

  const handleInput = (idx, val) => {
    const updated = [...values];
    updated[idx] = val;
    setValues(updated);
    onChange?.(updated);
  };

  const handleSubmit = () => {
    let payload = [];
    if (tab === 1) {
      payload = [{ id: ProfilerQuestionID.KIDS_COUNT, value: values[tab] }];
    } else if (tab === 2) {
      payload = [{ id: ProfilerQuestionID.KIDS_EDUCATION_COUNT, value: values[tab] }];
    }
    if (payload.length > 0) {
      onSubmit?.({ question: payload });
    }
  };

  return (
    <Box sx={cardStyles({ width, maxWidth, height: '100%', display: 'flex', flexDirection: 'column' })}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1, flexGrow: 1, justifyContent: 'flex-start' }}>
            <HumbeeTabs
            data={TABS}
            currentTab={tab}
            onChange={(e, newValue) => setTab(newValue)}
            getTabLabel={item => item.label}
            getTabKey={item => item.key}
            tabsSx={{ mb: 2, justifyContent: 'center' }}
            tabVariant={'small'}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flexGrow: 1, justifyContent: 'center' }}>
            {tab === 0 ? (
                <>
                <Box component='img' alt={CATEGORY_CONFIG.kids.title} width={180} height={180} src={CATEGORY_CONFIG.kids.image} />
                <Typography variant='body1' sx={{ textAlign: 'center' }}>
                    {CATEGORY_CONFIG.kids.subtitle}
                </Typography>
                </>
            ) : (
                <>
                    <Box component='img' alt={TABS[tab].label} width={120} height={120} src={TABS[tab].image} />
                    <CardHeader alignItems={'center'} title={getQuestionConfig(tab === 2 ? ProfilerQuestionID.KIDS_EDUCATION_COUNT : ProfilerQuestionID.KIDS_COUNT)?.question} />
                    <TextField
                        variant="outlined"
                        fullWidth
                        size='small'
                        value={values[tab] || ''}
                        onChange={e => handleInput(tab, e.target.value)}
                        placeholder='Enter number here'
                    />
                </>
            )}
            </Box>
            <CustomButton
                label={tab === 0 ? 'Continue' : 'Submit'}
                onClick={tab === 0 ? () => setTab(tab + 1) : handleSubmit}
                disabled={tab !== 0 && (values[tab] === '' || values[tab] === null || values[tab] === undefined)}
                size='small'
                sx={{ width: '100%', mt: 'auto' }}
            />
        </Box>
      
    </Box>
  );
};

export default KidsTabCard;
